import React, { Component } from "react";
// import { FormGroup, Label, Col } from "reactstrap";
// import Select from 'react-select';
import { axiosInstance2 } from "../../../../utils/axiosConfig";

import { Row, Col, Select } from 'antd';
import 'antd/dist/antd.css';

const { Option } = Select;

class ConnectorDropDown extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: []
        }
    }


    componentDidMount() {
        //let userName = this.props.user["https://myapp.com/UserName"];
        axiosInstance2.post('/api/fileTrace/getConnectors')
            .then(response => {
                
                if (response["data"]["error"]) {
                    return;
                }
                let connectorList = JSON.parse(JSON.stringify(response["data"]["data"]))
                this.setState({ data: connectorList });

            })//.catch((error) => {alert(error["message"])} );

    };

    render() {
        
        let data = this.state.data;
        //alert(JSON.stringify(data))
        data.sort(function (a, b) {
            return (a.alias.toUpperCase() > b.alias.toUpperCase()) ? 1 : -1;
        });

        let optionList = data.map( (conenctor) => {
            return(
                <Option key={conenctor.name} value={conenctor.name} >{conenctor.alias}</Option>
            )
        }) 
        console.log("Connectors => ", JSON.stringify(data));

        return (

            <Row type="flex" justify="center">
                <Col span={6}>Submission Method</Col>
                <Col span={18}>
                    <Select
                        allowClear
                        labelInValue
                        showSearch
                        style={{ width: '100%' }}
                        placeholder="Select a submission method"
                        optionFilterProp="children"
                        onChange={(selectedOption) => {
                            let val = null;
                            if(selectedOption !== undefined){
                                val = selectedOption.key;
                            }
                            this.props.updateSearchData("connector", val);
                        }}
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {optionList}
                    </Select>
                </Col>
            </Row>
        );
    }
}

export default ConnectorDropDown;